import { gql } from "@apollo/client";

export const REPLAY_CONNECTOR_CALL = gql`
  mutation ReplayConnectorCall($id: ID!) {
    replayConnectorCall(id: $id) {
      id
      connectorKey
      status
      durationMs
      createdDate
    }
  }
`;

const connectorCalls = { REPLAY_CONNECTOR_CALL };

export default connectorCalls;
